import { RefObject } from "react"
import { useNavigate } from "react-router-dom"
import { FormikProps } from "formik"
import { Integration } from "../../../types"
import { PrimaryBtn, DefaultBtn } from "../../../common/ui/buttons"
import {
  Settings,
  Status,
  Install,
  Troubleshoot
} from "../../../common/ui/integrations/tabs"
import { IntegrationContext } from "../../../common/ui/integrations/context"
import TabSkeleton from "./TabSkeleton"

interface IntegrationTabContentProps {
  tab: string
  integration: Integration | undefined
  isLoading: boolean
  isSavingSettings: boolean
  isLoadingStatus: boolean
  statusData: any[]
  formIntegrationRef: RefObject<FormikProps<Integration>>
  onSaveSettings: (values: Integration) => void
}

const IntegrationTabContent = ({
  tab,
  integration,
  isLoading,
  isSavingSettings,
  isLoadingStatus,
  statusData,
  formIntegrationRef,
  onSaveSettings
}: IntegrationTabContentProps) => {
  const navigate = useNavigate()
  return (
    <IntegrationContext.Provider value={{ formIntegrationRef }}>
      <div className="p-6 bg-[#F1F3FA] min-h-[calc(100vh-200px)]">
        {isLoading || !integration ? (
          <TabSkeleton />
        ) : (
          <>
            {tab === "settings" && (
              <div className="flex flex-col gap-5">
                <Settings
                  integration={integration}
                  isLoading={isLoading}
                  onSaveSettings={onSaveSettings}
                  open
                />
                <div className="flex justify-end gap-3 pt-1">
                  <DefaultBtn onClick={() => navigate(-1)}>Cancel</DefaultBtn>
                  <PrimaryBtn
                    isLoading={isSavingSettings}
                    disabled={isSavingSettings}
                    onClick={() => formIntegrationRef.current?.submitForm()}
                  >
                    Update Integration
                  </PrimaryBtn>
                </div>
              </div>
            )}
            {tab === "status" && (
              <Status
                integration={integration}
                statusData={statusData}
                isLoading={isLoadingStatus}
              />
            )}
            {tab === "install" && <Install integration={integration} />}
            {tab === "troubleshoot" && (
              <Troubleshoot integration={integration} />
            )}
          </>
        )}
      </div>
    </IntegrationContext.Provider>
  )
}

export default IntegrationTabContent
